/* ============================================================
   RAVUMI — hero: progresywne ladowanie wideo

   Strategia (od najszybszego do najladniejszego):
     1. Plakat  — widoczny natychmiast, zanim cokolwiek sie wczyta
     2. Wideo lekkie (720p) — startuje od razu, plynna petla
     3. Wideo HD (1080p)    — dociagane w tle; gdy gotowe, podmieniamy
                               je w momencie konca petli, wiec widz
                               nie widzi przeskoku

   Podmiana odbywa sie przez drugi, ukryty element wideo — dzieki
   temu nie ma migniecia ani czarnej klatki.
   ============================================================ */

(function () {
  'use strict';

  function init(hero) {
    var lekkie = hero.querySelector('[data-ravumi-video="lekkie"]');
    var adresHD = hero.getAttribute('data-ravumi-hd');
    if (!lekkie) return;

    // --- Autoodtwarzanie na telefonie ---
    // iOS blokuje autoplay, gdy wlaczony jest tryb oszczedzania energii
    // albo gdy strona wczytala sie w tle. Wtedy zostaje sam plakat.
    // Ponawiamy probe, a w ostatecznosci startujemy przy pierwszym
    // dotknieciu ekranu.
    function sprobujGrac() {
      if (!lekkie.paused) return;
      var p = lekkie.play();
      if (p && p.catch) p.catch(function () { /* blokada — czekamy na dotkniecie */ });
    }

    sprobujGrac();
    lekkie.addEventListener('loadeddata', sprobujGrac);

    // Gdy karta wraca na wierzch (typowe na telefonie)
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sprobujGrac();
    });

    // Ostatnia deska ratunku: pierwsze dotkniecie / klikniecie
    function naGest() {
      sprobujGrac();
      document.removeEventListener('touchstart', naGest);
      document.removeEventListener('click', naGest);
    }
    document.addEventListener('touchstart', naGest, { passive: true, once: true });
    document.addEventListener('click', naGest, { once: true });

    if (!adresHD) return;

    // Szanujemy ustawienie "ogranicz animacje" w systemie
    var bezRuchu = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (bezRuchu) {
      lekkie.removeAttribute('autoplay');
      lekkie.pause();
      return;
    }

    // Na wolnym laczu albo przy oszczedzaniu danych zostajemy przy lekkim
    var polaczenie = navigator.connection || navigator.mozConnection;
    if (polaczenie) {
      if (polaczenie.saveData) return;
      var typ = polaczenie.effectiveType || '';
      if (typ === 'slow-2g' || typ === '2g' || typ === '3g') return;
    }

    // Dociagamy HD w tle
    var hd = document.createElement('video');
    hd.muted = true;
    hd.loop = true;
    hd.playsInline = true;
    hd.setAttribute('muted', '');
    hd.setAttribute('playsinline', '');
    hd.setAttribute('aria-hidden', 'true');
    hd.preload = 'auto';
    hd.className = lekkie.className;
    hd.style.opacity = '0';
    hd.style.transition = 'opacity 0.6s ease';

    var podmienione = false;

    hd.addEventListener('canplaythrough', function () {
      if (podmienione) return;
      podmienione = true;

      // Startujemy HD w tym samym miejscu petli, w ktorym jest lekkie —
      // dzieki temu podmiana jest niewidoczna.
      try {
        hd.currentTime = lekkie.currentTime || 0;
      } catch (e) {
        hd.currentTime = 0;
      }

      var start = hd.play();
      if (start && start.then) {
        start.then(pokaz).catch(function () {
          hd.remove();   // autoodtwarzanie zablokowane — zostajemy przy lekkim
        });
      } else {
        pokaz();
      }
    });

    function pokaz() {
      hd.style.opacity = '1';
      // Lekkie wideo usuwamy dopiero po przenikaniu
      window.setTimeout(function () {
        lekkie.pause();
        lekkie.style.display = 'none';
      }, 650);
    }

    hd.addEventListener('error', function () {
      hd.remove();   // nie udalo sie — lekkie gra dalej, nic sie nie dzieje
    });

    hd.src = adresHD;
    lekkie.parentNode.appendChild(hd);
  }

  function start() {
    var hero = document.querySelector('[data-ravumi-hero]');
    if (hero) init(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
